// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"a19b297f","885":"6e876a69"}[chunkId] + ".chunk.js";
};